import Parse from "parse";
import { TicketMeta } from "../../features/tickets/_shared";
import type { Project } from "./Project";
import type { _Role } from "./_Role";
import type { _User } from "./_User";

type OD3_Tenant = Parse.Object;

export interface TicketAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  assignedroles: Parse.Relation<Ticket, _Role>;
  assignedusers: Parse.Relation<Ticket, _User>;
  enabled: boolean;
  description?: string;
  latestPriorityValue?: number;
  meta?: TicketMeta;
  project?: Project;
  tenant?: OD3_Tenant;
  title?: string;
  user?: _User;
}

export class Ticket extends Parse.Object<TicketAttributes> {
  static className: string = "OD3_Maintenance_Ticket";

  constructor(data?: Partial<TicketAttributes>) {
    super("OD3_Maintenance_Ticket", data as TicketAttributes);
  }

  get assignedroles(): Parse.Relation<Ticket, _Role> {
    return super.relation("assignedroles");
  }
  get assignedusers(): Parse.Relation<Ticket, _User> {
    return super.relation("assignedusers");
  }
  get enabled(): boolean {
    return super.get("enabled");
  }
  set enabled(value: boolean) {
    super.set("enabled", value);
  }
  get latestPriorityValue(): number | undefined {
    return super.get("latestPriorityValue");
  }
  set latestPriorityValue(value: number | undefined) {
    super.set("latestPriorityValue", value);
  }
  get meta(): TicketMeta | undefined {
    return super.get("meta");
  }
  set meta(value: TicketMeta | undefined) {
    super.set("meta", value);
  }
  get project(): Project | undefined {
    return super.get("project");
  }
  set project(value: Project | undefined) {
    super.set("project", value);
  }
  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
  get title(): string | undefined {
    return super.get("title");
  }
  set title(value: string | undefined) {
    super.set("title", value);
  }
  get user(): _User | undefined {
    return super.get("user");
  }
  set user(value: _User | undefined) {
    super.set("user", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_Ticket", Ticket);
